enum UserPermission {
  AllDashAppsAccess = 'trackd:dashapp:readAll',
  DashAppAccess = 'trackd:dashapp:read',
}

export default UserPermission;
